import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Switch from "../../Form/Switch";
import CardMedia from "../../Media/CardMedia";
import { useTranslationApp } from "../../../lib/i18next";
import {
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA,
} from "../../../i18n/keysTranslations";
import { BORDER_RADIUS } from "../../../utils/constants";
import { INPUT_COLOR_BORDER } from "../../../utils/colors";

const THUMB_SIZE = 56;

const AdditionalAssetToggleCard = ({
  asset,
  index,
  label,
  isEnabled = true,
  onToggleAsset = () => {},
  onPreviewImage = () => {},
}) => {
  const { t } = useTranslationApp();
  const assetNumber = index + 1;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 1.5,
        py: 1.25,
        borderRadius: BORDER_RADIUS,
        border: "1px solid",
        borderColor: INPUT_COLOR_BORDER,
        bgcolor: "background.paper",
        opacity: isEnabled ? 1 : 0.5,
        transition: "opacity 0.2s",
      }}
    >
      <Box
        component="button"
        type="button"
        onClick={() => onPreviewImage({ url: asset.urlImage })}
        aria-label={t(MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA, {
          number: assetNumber,
        })}
        sx={{
          p: 0,
          border: "none",
          background: "none",
          cursor: "pointer",
          borderRadius: 1.5,
          overflow: "hidden",
          flexShrink: 0,
          "&:hover": {
            filter: "brightness(0.92)",
          },
        }}
      >
        <CardMedia
          url={asset.urlImage}
          sx={{
            width: THUMB_SIZE,
            height: THUMB_SIZE,
            objectFit: "contain",
            objectPosition: "center",
            borderRadius: 1.5,
            backgroundColor: "action.hover",
            display: "block",
          }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: 0.25,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            fontSize: "12px",
            color: "text.primary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Typography>

        <Tooltip title={asset.prompt || ""} placement="top" arrow>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontSize: "13px",
              lineHeight: 1.4,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {asset.prompt}
          </Typography>
        </Tooltip>
      </Box>

      <Switch
        id={`additional-asset-toggle-${index}`}
        isActive={isEnabled}
        size="small"
        hasLabel={false}
        onChangeIsActive={(checked) =>
          onToggleAsset({ index, enabled: checked })
        }
        sx={{
          flexShrink: 0,
          "aria-label": t(MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA, {
            number: assetNumber,
          }),
        }}
      />
    </Box>
  );
};

export default AdditionalAssetToggleCard;
